'use client';

import type { ReactNode } from 'react';
import { TextLink } from '@petsmart-ui/sparky';
import { handleServiceClick } from '@libs/experience-api';
import { usePageLayout } from '@libs/common-next';
import type { LinkActionColor } from '../../types';
import { COLOR_TABLE } from '../../constants';

interface TextProps {
    color?: LinkActionColor;
    children: ReactNode;
    className?: string;
    onClick?: () => void;
    href?: string;
}

export function ColoredTextLink({ color: c, ...p }: TextProps) {
    const { isAuthenticated } = usePageLayout();

    const props = {
        ...(c &&
            c !== 'Blue' && {
                style: {
                    color: COLOR_TABLE[c],
                },
            }),
        ...p,
    };

    return (
        <TextLink
            {...props}
            onClick={event => {
                handleServiceClick({
                    authType: isAuthenticated,
                    event,
                    link: props.href,
                });

                props.onClick?.();
            }}
        />
    );
}
